/*
 * @Author: Vic Li
 * @Date: 2021-11-19 10:19:33
 * @LastEditTime: 2023-02-23 15:25:43
 * @LastEditors: jackson
 * @Description:
 * @FilePath: \hm-app-configd:\work\HM-V2\hm-app-main\src\plugin\axios\index.js
 *
 */
import axios from 'axios'
import { message } from 'ant-design-vue'
// import util from '@/libs/util'
// import Vue from 'vue'
// import router from '@/router'
import GATEWAY from './gateway'
import THROTTLE from './throttle'

const Message = message

// 创建一个错误
function errorCreate (msg) {
  const error = new Error(msg)
  // errorLog(error)
  warningLog(error)
  throw error
}

// 记录和显示错误
function errorLog (error) {
  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    console.log(error)
  }
  // 显示提示
  if (error.message) {
    Message.error(error.message)
  }
}
function warningLog (warn) {
  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    console.warn(warn)
  }
  Message.destroy()
  // 显示提示
  Message.warning(warn.message)
}
// 跳转到登录页
// TODO: 应该跳转到SSO的登录页
// function gotoLogin () {
//   util.cookies.remove('token')
//   router.replace({
//     name: 'login',
//     query: {
//       redirect: Vue.prototype.$routerPath
//     }
//   })
//   // window.location.href = `${window.$hm_ssoFullUrl}&response_status=401`
// }

// 创建一个 axios 实例
const selfAxios = axios.create({
  timeout: 180000 // 请求超时时间
})

// 请求拦截器
selfAxios.interceptors.request.use(
  config => {
    // const { $pageName, $routerPath } = Vue.prototype
    // 在请求发送之前做一些处理
    // const token = util.cookies.get('token')
    const newHeaders = {
      // sysCode: 'HMSYS101', // 添加系统代号
      // loginType: 'web', // 设置pc端
      // Authorization: token ? `Bearer ${token}` : '', // 请求携带token
      // pageName: encodeURIComponent($pageName), // 添加 pageName
      // router: $routerPath, // 添加 router
      ...config.headers
    }
    config.headers = newHeaders
    if (config.throttle) {
      let cancelFun = null
      config.cancelToken = new axios.CancelToken(cancel => {
        cancelFun = cancel
      })
      THROTTLE.stopRepeatRequest(config.url, cancelFun)
    }
    return config
  },
  error => {
    // 发送失败
    console.log(error)
    return Promise.reject(error)
  }
)

/**
 * @name 需要返回完整响应对象的code
 * 200: 正常响应
 * 7799: 该地区和税种暂未配置校验规则(规则引擎'hm-base-rule')
 * 8840: 登录信息不存在,请先完善登陆信息(RPA)
 * 8850: 创建任务 - 零申报适用时间已过
 * 8841: rpa错误提示
 */
const GOOD_TO_GO_CODE_LIST = [200, 7799, 8840, 8850, 8841]

// 响应拦截器
selfAxios.interceptors.response.use(
  response => {
    THROTTLE.allowRequest()
    // 开放响应头拿到后端在响应头的文件名和类型
    if (response.config.headers.retainHeaders) {
      return response
    } else {
    // dataAxios 是 axios 返回数据中的 data
      const dataAxios = response.data
      // 这个状态码是和后端约定的
      const { code } = dataAxios
      // 根据 code 进行判断
      if (code === undefined || GOOD_TO_GO_CODE_LIST.includes(Number(code))) {
        return dataAxios
      } else {
        switch (Number(code)) {
          // 页面api只需要判断是否有返回response
          // case 7799: // 规则引擎'hm-base-rule', 7799 该地区和税种暂未配置校验规则 ;
          //   // Message.warning(dataAxios.msg)
          //   return dataAxios
          default:
          // 不是正确的 code 统一报错
          // errorCreate(`[ code: xxx ] ${dataAxios.msg}: ${response.config.url}`)
            errorCreate(`${dataAxios.msg}`)
            break
        }
      }
    }
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400: error.message = '请求错误'; break
        case 401:
          // error.message = '当前账号已在其他设备登录，如非本人操作请检查账号密码是否已泄露，及时修改密码！'
          error.message = '当前登录已失效，请重新登录。'
          setTimeout(() => {
            // gotoLogin()
          }, 3000)
          break
        case 403: error.message = '拒绝访问'; break
        case 404: error.message = '请求地址出错'; break
        case 408: error.message = '请求超时'; break
        case 500: error.message = '服务器内部错误'; break
        case 501: error.message = '服务未实现'; break
        case 502: error.message = '网关错误'; break
        case 503: error.message = '服务不可用'; break
        case 504: error.message = '网关超时'; break
        case 505: error.message = 'HTTP版本不受支持'; break
        default: break
      }
    }
    // if (util.cookies.get('uuid')) {
    //   errorLog(error)
    //   // token失效后去除uuid 防止弹出多条登录失效消息
    //   if (error.response && error.response.status === 401) {
    //     util.cookies.remove('uuid')
    //   }
    // }
    return Promise.reject(error)
  }
)
/**
 * @description: 二次封装的请求方法
 * @const {Json} GATEWAY 后端微服务网关路由表
 * @param {Object} config 请求的配置项
 * @param {String} config.proxy 项目内代理转发标识, 默认为 '/japi'
 * @param {String} config.service 接口对应后端的微服务
 * @param {Boolean} config.mock 是否mock
 * @param {String} config.url 接口请求地址
 * @param {String} config.method 接口请求方式
 * @param {Object} config.params get接口请求参数
 * @param {Object} config.data post接口请求参数
 * @return {Function} 请求函数
 */
const myFetch = function (config) {
  const GLOBAL_MOCK = false // 全局mock
  const {
    throttle = true,
    proxy = '/japi',
    service,
    mock = false,
    url = '',
    method = 'get',
    params = {},
    data = {},
    ...rest
  } = config
  let prefix = ''
  // 后端网关配置表和后端微服务
  if (GATEWAY && service) {
    prefix = GATEWAY[service] ? GATEWAY[service] : ''
  }
  const fullUrl = `${prefix}${url}`
  const axiosConfig = {
    throttle,
    baseURL: (GLOBAL_MOCK || mock) ? '/mock' : proxy,
    method,
    url: fullUrl,
    params,
    data,
    ...rest
  }
  return selfAxios(axiosConfig)
}

export default myFetch



// WEBPACK FOOTER //
// ./src/plugin/axios/index.js